module.exports = __webpack_public_path__ + "static/img/Case1_3.c5d9c80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case5/Case1_3.jpg
// module id = 91kQ
// module chunks = 1